import { Section } from '../models/section.model';

export class AddSections {
    static readonly type = '[Section] AddSections';

    constructor(public payload: Section[]) {}
}
